import { render, staticRenderFns } from "./ColorVariation.vue?vue&type=template&id=75e05368&scoped=true&"
import script from "./ColorVariation.vue?vue&type=script&lang=ts&"
export * from "./ColorVariation.vue?vue&type=script&lang=ts&"
import style0 from "./ColorVariation.vue?vue&type=style&index=0&id=75e05368&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e05368",
  null
  
)

export default component.exports